import { useTranslations } from "next-intl";
import { Link } from '@/i18n/navigation';
import { Button } from './ui/button';
import LocaleSwitcher from "./LocaleSwitcher";

interface FooterProps {

}

const socialLinks: { linkPath: string, iconPath: string }[] = [
  {
    linkPath: "https://www.instagram.com/invento.ch/",
    iconPath: "/social-icons/ig.svg",
  },
  {
    linkPath: "https://www.tiktok.com/@invento.ch",
    iconPath: "/social-icons/tiktok.svg",
  },
  {
    linkPath: "https://www.youtube.com/@inventoag",
    iconPath: "/social-icons/yt.svg",
  },
  {
    linkPath: "https://www.linkedin.com/company/invento-ag",
    iconPath: "/social-icons/linkedin.svg",
  },
  {
    linkPath: "https://www.facebook.com/people/Invento-AG/100069503054402/",
    iconPath: "/social-icons/fb.svg",
  },
]

function Footer(props: FooterProps) {
  const t = useTranslations('Footer');

  return (
    <footer className='bg-primary text-white border-t-[3px] border-accent relative z-30 font-[Outfit]'>
      <div className='mx-auto max-w-[1920px] px-14 py-14 flex flex-col flex-wrap gap-10 justify-between'>
        <div className='flex flex-col gap-4 items-start'>
          <Link href="/">
            <svg className='w-[150px]' viewBox="0 0 736 135" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_348_2070)">
                <path d="M32.25 28.71H0V129H32.25V28.71Z" fill="white" />
                <path d="M110.52 23.55C82.12 23.55 59.09 46.5801 59.09 74.9801V129.01H91.34V74.9801C91.34 64.3901 99.93 55.8 110.52 55.8C121.11 55.8 129.69 64.3901 129.69 74.9801V129.01H161.94V74.9801C161.94 46.5801 138.92 23.55 110.52 23.55Z" fill="white" />
                <path d="M385.39 43.41C380.9 37.87 375.21 33.55 368.33 30.43C361.45 27.32 353.61 25.76 344.83 25.76C336.83 25.76 329.51 27.05 322.85 29.64C316.2 32.23 310.41 35.89 305.49 40.61C300.57 45.33 296.77 50.94 294.08 57.43C291.39 63.92 290.05 71.03 290.05 78.77C290.05 89.46 292.36 98.78 296.98 106.74C298.31 109.03 299.81 111.15 301.44 113.14C338.98 155.17 389.46 121.27 389.46 121.27L378.54 97.74C373.69 100.95 368.61 103.33 363.3 104.87C357.99 106.41 352.38 107.18 346.48 107.18C341.17 107.18 336.51 106.34 332.52 104.67C328.52 103 325.37 100.69 323.08 97.74C320.79 94.79 319.61 91.35 319.54 87.42H394.86C396.43 78.63 396.37 70.49 394.66 62.98C392.96 55.48 389.86 48.96 385.37 43.41H385.39ZM321.52 65.68C322.04 60.63 324.35 56.6 328.45 53.58C332.55 50.57 337.71 49.06 343.94 49.06C350.17 49.06 354.99 50.57 358.59 53.58C362.2 56.6 364.06 60.63 364.2 65.68H321.52Z" fill="white" />
                <path d="M230.16 95.1L210.61 28.71H176L210.8 127.3C230.09 127.7 228.67 127.64 252.69 127.3L283.08 28.71H249.26L230.16 95.1Z" fill="white" />
                <path d="M728.39 52.31C723.67 44.25 717.11 37.81 708.72 32.99C700.33 28.17 690.66 25.76 679.71 25.76C671.51 25.76 664.01 27.19 657.19 30.04C650.37 32.89 644.47 36.79 639.49 41.74C634.51 46.69 630.66 52.36 627.94 58.75C625.22 65.14 623.86 71.84 623.86 78.86C623.86 88.49 626.24 97.34 630.99 105.41C635.74 113.47 642.31 119.91 650.7 124.73C659.09 129.55 668.76 131.96 679.71 131.96C687.91 131.96 695.41 130.52 702.23 127.63C709.05 124.75 714.94 120.85 719.93 115.93C724.91 111.01 728.75 105.36 731.44 98.97C734.13 92.58 735.47 85.88 735.47 78.86C735.47 69.22 733.11 60.37 728.39 52.31ZM700.76 92.33C698.66 96.13 695.78 99.07 692.11 101.13C688.44 103.19 684.31 104.23 679.72 104.23C675.13 104.23 671 103.2 667.33 101.13C663.66 99.06 660.76 96.13 658.63 92.33C656.5 88.53 655.43 84.04 655.43 78.86C655.43 73.68 656.48 69.19 658.58 65.39C660.68 61.59 663.56 58.65 667.23 56.59C670.9 54.52 675.06 53.49 679.72 53.49C684.38 53.49 688.54 54.52 692.21 56.59C695.88 58.66 698.75 61.59 700.81 65.39C702.87 69.19 703.91 73.68 703.91 78.86C703.91 84.04 702.86 88.53 700.76 92.33Z" fill="white" />
                <path d="M602.88 102.7C600.88 103.19 598.86 103.44 596.83 103.44C593.09 103.44 590.04 102.36 587.68 100.19C585.32 98.03 584.14 94.26 584.14 88.88V54.26H607.64V28.69H584.14V0H551.89V28.71H532.42V54.28H551.89V94.5C551.89 106.96 555.07 116.31 561.43 122.57C567.79 128.83 576.54 131.96 587.69 131.96C592.54 131.96 597.13 131.35 601.46 130.14C605.79 128.93 609.49 127.47 612.57 125.76L608.44 100.49C606.74 101.47 604.88 102.21 602.88 102.7Z" fill="white" />
                <path d="M466.91 23.27C438.51 23.27 415.48 46.3 415.48 74.7V128.73H447.73V74.7C447.73 64.11 456.32 55.52 466.91 55.52C477.5 55.52 486.08 64.11 486.08 74.7V128.73H518.33V74.7C518.33 46.3 495.31 23.27 466.91 23.27Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_348_2070">
                  <rect width="735.47" height="134.18" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Link>
          <div className="flex flex-col md:flex-row md:justify-between gap-5 w-[100%]">
            <div className="flex-none font-normal leading-[150%]">
              Invento AG<br />Langenhagstrasse 3<br />4147 Aesch<br />Schweiz
            </div>
            <div className="flex-none flex flex-col gap-1">
              <h3 className='opacity-80 uppercase text-sm'>{t("account-title")}</h3>
              <Link className="leading-[150%]" href="/kundenkonto">{t("account-title")}</Link>
              <Link className="leading-[150%]" href="/kundenkonto/bestellungen">{t("account-orders")}</Link>
            </div>
            <div className="flex-none flex flex-col gap-1">
              <h3 className='opacity-80 uppercase text-sm'>{t("products-title")}</h3>
              <Link className="leading-[150%]" href="/kategorie/reinigungs-und-pflegemittel">{t("products-1")}</Link>
              <Link className="leading-[150%]" href="/kategorie/grundierungen-und-rostbehandlung">{t("products-2")}</Link>
              <Link className="leading-[150%]" href="/kategorie/schmier-und-konservierungsmittel">{t("products-4")}</Link>
              <Link className="leading-[150%] " href="/kategorie/klebe-und-dichtstoffe">{t("products-3")}</Link>
              <Link className="leading-[150%]" href="/kategorie/zubehoer">{t("products-5")}</Link>
            </div>
            <div className="flex-none flex flex-col gap-1">
              <h3 className='opacity-80 uppercase text-sm'>{t("about-title")}</h3>
              <Link className="leading-[150%]" href="/ueber-uns">{t("about-company")}</Link>
              <Link className="leading-[150%]" href="/blog">{t("about-blog")}</Link>
              <Link className="leading-[150%]" href="/standorte">{t("about-franchise")}</Link>
              <Link className="leading-[150%]" href="/services">{t("about-service")}</Link>
              <Link className="leading-[150%]" href="/ueber-uns#karriere">{t("about-jobs")}</Link>
              <Link className="leading-[150%]" href="/#kontakt">{t('about-contact')}</Link>
            </div>
            <div className="flex-none flex flex-col gap-1">
              <h3 className='opacity-80 uppercase text-sm'>{t("legal-title")}</h3>
              <Link className="leading-[150%]" href="/impressum">{t("legal-imprint")}</Link>
              <Link className="leading-[150%]" href="/datenschutz">{t("legal-data-protection")}</Link>
              <Link className="leading-[150%]" href="/agb">{t("legal-agb")}</Link>
            </div>
            {/*<div className="flex-none flex flex-col gap-2.5">
              <h3 className='opacity-80 uppercase text-sm'>{t("languages")}</h3>
              <LocaleSwitcher className=" text-[#18181b]" />
            </div>*/}
          </div>
        </div>
        <div className="w-[100%] flex flex-row justify-center content-center p-2.5 gap-2.5">
          {socialLinks.map((l, i) => (
            <a href={l.linkPath} key={i}>
              <img src={l.iconPath} width={24} />
            </a>
          ))}
        </div>
      </div>
    </footer>
  )
}

export default Footer;
